import { writable } from "svelte/store";
import { DashboardService } from "../../services/dashboard.service";
export const tiles = writable(null);
export function loadDashboard() {
    loadTiles();
}
async function loadTiles() {
    let _resp = await DashboardService.getDashboardTiles().toPromise();
    tiles.set(_resp.payload);
}
